<template>
    <section class="badges-wrapper pt-80px position-relative">
        <div class="container">
            <div class="row">

                <!-- Sidebar -->
                <div class="col-md-2">
                    <questions-sidebar />
                </div>

                <!-- All Badges -->
                <div class="col-md-7">

                    <div class="badges-tab-wrapper">
                        <badge-header :title="dlabData.badgeTab.title" :description="dlabData.badgeTab.description" />

                        <div class="badge-lists">
                            <div class="badge-lists-box">
                                <h1 v-if="dlabData.badgeTab.badges.question_badge.title">
                                    {{dlabData.badgeTab.badges.question_badge.title}}
                                </h1>
                                <question-badge :badges="dlabData.badgeTab.badges.question_badge.items" />
                            </div>

                            <div class="badge-lists-box">
                                <h1 v-if="dlabData.badgeTab.badges.answer_badge.title">
                                    {{dlabData.badgeTab.badges.answer_badge.title}}
                                </h1>
                                <question-badge :badges="dlabData.badgeTab.badges.answer_badge.items" />
                            </div>
                        </div>
                    </div>
                        
                </div>

                <!-- Right Sidebar -->
                <div class="col-md-3">
                    <questions-sidebar-2 />
                </div>
            </div>
        </div>
    </section>
</template>


<script>
import dlabData from '@/store/store.js'
import QuestionsSidebar from '../sidebars/QuestionsSidebar.vue';
import QuestionsSidebar2 from '../sidebars/QuestionsSidebar2.vue';
import QuestionBadge from '../cards/QuestionBadge.vue';

export default {
    name: 'Questions',
    components: {
        QuestionsSidebar,
        QuestionsSidebar2,
        QuestionBadge,
    },
    data() {
        return {
            dlabData,
        }
    },
    methods: {
        
    },
    mounted() {
    }
}
</script>